"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EtherspotWallet = void 0;
const userop_1 = require("userop");
const ethers_1 = require("ethers");
const typechain_1 = require("userop/dist/typechain");
const constants_1 = require("userop/dist/constants");
const middleware_1 = require("userop/dist/preset/middleware");
const typechain_2 = require("./typechain");
const variables_1 = require("./constants/variables");
class EtherspotWallet extends userop_1.UserOperationBuilder {
    constructor(signer, rpcUrl, opts) {
        var _a;
        super();
        /// Resolves the nonce and init code for the EtherspotWallet contract creation.
        this.resolveAccount = (ctx) => __awaiter(this, void 0, void 0, function* () {
            const [nonce, code] = yield Promise.all([
                this.entryPoint.getNonce(ctx.op.sender, this.nonceKey),
                this.provider.getCode(ctx.op.sender),
            ]);
            ctx.op.nonce = nonce;
            ctx.op.initCode = code === "0x" ? this.initCode : "0x";
        });
        this.signer = signer;
        this.provider = new userop_1.BundlerJsonRpcProvider(rpcUrl).setBundlerRpc(opts === null || opts === void 0 ? void 0 : opts.overrideBundlerRpc);
        this.entryPoint = typechain_1.EntryPoint__factory.connect((opts === null || opts === void 0 ? void 0 : opts.entryPoint) || constants_1.ERC4337.EntryPoint, this.provider);
        this.factory = typechain_2.EtherspotWalletFactory__factory.connect((opts === null || opts === void 0 ? void 0 : opts.factory) || variables_1.Variables.ETHERSPOT_FACTORY, this.provider);
        this.initCode = '0x';
        this.nonceKey = (_a = opts === null || opts === void 0 ? void 0 : opts.nonceKey) !== null && _a !== void 0 ? _a : 0;
        this.proxy = typechain_2.EtherspotWallet__factory.connect(ethers_1.ethers.constants.AddressZero, this.provider);
    }
    /// Initializes a EtherspotWallet object and returns it.
    static init(signer, rpcUrl, opts, signature) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const instance = new EtherspotWallet(signer, rpcUrl, opts);
            instance.initCode = ethers_1.ethers.utils.hexConcat([
                instance.factory.address,
                instance.factory.interface.encodeFunctionData('createAccount', [
                    yield instance.signer.getAddress(),
                    ethers_1.ethers.BigNumber.from((_a = opts === null || opts === void 0 ? void 0 : opts.salt) !== null && _a !== void 0 ? _a : 0),
                ]),
            ]);
            const eoa = yield instance.signer.getAddress();
            const sca = yield instance.factory.getAddress(eoa, ethers_1.ethers.BigNumber.from((_b = opts === null || opts === void 0 ? void 0 : opts.salt) !== null && _b !== void 0 ? _b : 0));
            instance.proxy = typechain_2.EtherspotWallet__factory.connect(sca, instance.provider);
            const base = instance
                .useDefaults({
                sender: instance.proxy.address,
                signature: signature !== null && signature !== void 0 ? signature : yield instance.signer.signMessage(ethers_1.ethers.utils.arrayify(ethers_1.ethers.utils.keccak256('0xdead'))),
            })
                .useMiddleware(instance.resolveAccount)
                .useMiddleware((0, middleware_1.getGasPrice)(instance.provider));
            const withPM = (opts === null || opts === void 0 ? void 0 : opts.paymasterMiddleware)
                ? base.useMiddleware(opts.paymasterMiddleware)
                : base.useMiddleware((0, middleware_1.estimateUserOperationGas)(instance.provider));
            return withPM.useMiddleware((0, middleware_1.signUserOpHash)(instance.signer));
        });
    }
    /// Executes a transaction on the network.
    execute(to, value, data) {
        return this.setCallData(this.proxy.interface.encodeFunctionData('execute', [to, value, data]));
    }
    /// Executes a batch transaction on the network.
    executeBatch(calls) {
        return this.setCallData(this.proxy.interface.encodeFunctionData('executeBatch', [
            calls.map((call) => call.to),
            calls.map((call) => call.value),
            calls.map((call) => call.data),
        ]));
    }
}
exports.EtherspotWallet = EtherspotWallet;
